import React, {useState, useEffect} from "react";
import {SetMetaData} from './../../helper/page-title';
import moment from 'moment';
import {post_api_call,
        error_api_call
      } from './../../actions/action-creators/common';
import { alertResponseMessage } from "../../actions/action-creators/response";
//Modal
import ModalMasterDetail from "../../modal/master-detail";
import FormDataGlosco from "../../data/formData/glosco/requests";
const {
    fieldGloscoReqView,
    fieldGloscoReqCompactView
} = FormDataGlosco;

function GloscoRequestList(props){
    SetMetaData("Manage GLOSCO Requests", "", "");
    const [isLoading, setIsLoading] = useState(true);
    const [modalLoader, setModalLoader] = useState({detail: false});
    const [modalToggle, setModalToggle] = useState({detail: false});
    const [masterTableData, setMasterTableData] = useState([]);
    const [modalViewData, setModalViewData] = useState({});
    
    //Get Data for Dropdown
    const fetchMasterTableList = async() => {
      try{
        const masterApiData = await post_api_call('glosco-requests', {});
        if(masterApiData.status === 200){
          setMasterTableData(masterApiData.data);
          setIsLoading(false);
        }
      }catch(e){
        error_api_call({error: `admin|glosco|request-list|fetchMasterTableList|${e}`});
      }
    }
    useEffect(() => {
      //Initial API Data
      fetchMasterTableList();
    }, []);
    //View Data
    const loadViewModal = async(e, load_type, data) => {
      e.preventDefault();
      try{
        //Page Loading
        toggleModal(e, load_type, true, '', load_type);
        setModalLoader({...modalLoader, [load_type]: true});

        if(load_type === 'detail'){
            // data.nominating_type = data.nomination
            //                         ? (data.nomination?.school_count ? 'A group of schools' : 'Only one school')
            //                         : '';
            // data.is_affi_internationally = data.nomination
            //                                 ? (data.nomination?.organisation_name ? 'Yes' : 'No')
            //                                 : '';
            // data.school_count = data.nomination?.school_count
            //                     ? (data.nomination?.school_count > 10 ? '10+' : data.nomination?.school_count)
            //                     : '';
            setModalViewData({...data});
        }
        setModalLoader({...modalLoader, [load_type]: false});
      }catch(error){
        error_api_call({error: `admin|glosco|request-list|loadViewModal|${error}`});
        alertResponseMessage({alert_type: 2, message: "Error Loading Data"});
      }
    }
    //Approve Toggle
    const approveToggle = async(e, master_id) => {
        e.preventDefault();
        try{
          // status_change
          if (window.confirm(`Are you sure you want to approve this request?`)){
            const targetTag = e.target.tagName.toLowerCase();
            if(targetTag === 'i'){
                e.target.parentElement.disabled = true;
            }else{
                e.target.disabled = true;
            }
            const statusApiData = await post_api_call(`glosco/approval`, {id: master_id});
            if(statusApiData.status === 200){
                fetchMasterTableList();
                alertResponseMessage({alert_type: 1, message: `Request approved Successfully!`});
            }
            if(targetTag === 'i'){
                e.target.parentElement.disabled = false;
            }else{
                e.target.disabled = false;
            }
          }
        }catch(e){
            const targetTag = e.target.tagName.toLowerCase();
            if(targetTag === 'i'){
                e.target.parentElement.disabled = false;
            }else{
                e.target.disabled = false;
            }
          error_api_call({error: `admin|glosco|request-list|approveToggle|${e}`});
        }
    }
    // Toggle Modal
    const toggleModal = (e, modal_type, toggleState, index='', form_type='') => {
        try{
            if(toggleState){
                e.preventDefault();
            }
            // if(toggleState){
            //     // var data = {};
            //     // var heading = '';
            //     var legendTitle = 'Details';
            //     // switch (form_type) {
            //     //     case 'new':
            //     //         // heading = 'New Hub Details',
            //     //         setOppSubTypeOpt([]);
            //     //         setNewFormData({...fieldValuesHub});
            //     //         setMasterFieldData([{form_type: 'new', label: legendTitle, fields: [...fieldHub]}]);
            //     //         break;
            //     //     default: 
            //     //         break;
            //     // }
            //     // setErrorData({...errorData, [form_type]: []});
            //     setActiveForm(form_type);
            // }
            setModalToggle({...modalToggle, [modal_type]: toggleState});
            // if((form_type === 'new'
            //     || form_type === 'edit'
            // ) && dropdownOpt.type.length === 0){
            //   fetchSelectList('crud_dropdown', 'opportunity/options/hub-admin-entry');
            // }
        }catch(error){
            console.log(error)
        }
    }

    return (
        <>
        <div className="row">
            <div className="col-lg-12 grid-margin stretch-card">
            <div className="card">
                <div className="card-body table-responsive sticky-table">
                {/* <h4 className="card-title">Basic Table</h4> */}
                {/* <p className="card-description"> Add class <code>.table</code></p> */}
                <table className="table">
                    <thead>
                    <tr>
                        <th>User Id</th>
                        {(props.userRoleIds.includes(2)
                            || props.userRoleIds.includes(7)
                        ) && (
                            <>
                            <th>School</th>
                            <th>Branch</th>
                            </>
                        )}
                        <th className="w-200p">Name</th>
                        <th className="w-200p">Class</th>
                        <th>Level</th>
                        <th>IFSPD Program</th>
                        <th>Session</th>
                        <th>Role</th>
                        <th>Award</th>
                        <th>Request Date<br/>(DD/MM/YYYY)</th>
                        <th>User Portfolio</th>
                        {/* <th>Status</th> */}
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {isLoading
                    ? 
                    <tr className="text-center">
                        <td colSpan={(props.userRoleIds.includes(2) || props.userRoleIds.includes(7)) ? 13 : 11}>
                            <div className="p-4">
                                <img alt="Loader" src={require('../../assets/images/Image-Loader.gif')} />
                            </div>
                        </td>
                    </tr>
                    :
                    <>
                    {masterTableData.map((data, data_index) => (
                        <tr key={`tableData_${data_index}`}>
                        <td>{data.user_id}</td>
                        {(props.userRoleIds.includes(2)
                            || props.userRoleIds.includes(7)
                        ) && (
                            <>
                                <td>{data.school_name}</td>
                                <td>{data.branch_name}</td>
                            </>
                        )}
                        <td>{data.first_name} {data.last_name}</td>
                        <td>{data.class_name}</td>
                        <td>{data.level_name}</td>
                        <td>{data.program_name}</td>
                        <td>
                            {data.glosco_data
                            ?.map(g => g.session_name)
                            .filter(Boolean)
                            .join(', ') || ''}
                        </td>
                        <td>
                            {data.glosco_data
                            ?.map(g => g.role)
                            .filter(Boolean)
                            .join(', ') || ''}
                        </td>
                        <td>
                            {data.glosco_data
                            ?.flatMap(g => g.award_data?.map(a => a.award_name) || [])
                            .filter(Boolean)
                            .join(', ') || ''}
                        </td>

                        <td>{moment(data.created_at).format("DD/MM/yyyy")}</td>
                        <td><a href={`/student/${data.url}`} target="_blank" rel="noreferrer">View</a></td>
                        {/* <td><label className={`badge ${data.status === 'Active' ? 'badge-success' : 'badge-danger'}`}>{data.status}</label></td> */}
                        <td className="d-flex">
                            <button onClick={(e) => loadViewModal(e, 'detail', data)} className="btn btn-sm btn-twitter" title="View Data"><i className="mdi mdi-eye"></i></button>
                            <button onClick={(e) => approveToggle(e, data.id)} className={`btn btn-sm ms-2 ${data.active_status_id === 1 ? 'btn-danger' : 'btn-success'}`} title="Approve"><i className="mdi mdi-check-outline"></i></button>
                        </td>
                        </tr>
                    ))}

                    {masterTableData.length === 0 && (
                        <tr className="text-center">
                            <td colSpan={(props.userRoleIds.includes(2) || props.userRoleIds.includes(7)) ? 13 : 11}>
                                <div className="p-4">
                                    No Pending Requests. 
                                </div>
                            </td>
                        </tr>
                    )}
                    </>
                    }
                    </tbody>
                </table>
                </div>
            </div>
            </div>
        </div>
        {/* View Details */}
        <ModalMasterDetail
            data={modalViewData}
            isShow={modalToggle.detail}
            _toggleModal={(e, state) => toggleModal(e, 'detail', state)}
            loader={modalLoader.detail}
            _formData={[{label: "Detail", fields: (props.userRoleIds.includes(2) || props.userRoleIds.includes(7)) ? [...fieldGloscoReqView] : [...fieldGloscoReqCompactView]}]}
            title={"Request Details"}
        />
        </>
    )    
}

export default GloscoRequestList;